<template>
    <div class="curtain-grey" @click.stop="close">
        <div class="body-user-info" @click.stop="">
            <img class="user-picture" :src="userPicture" alt="">
            <div class="user-nick-name">
                <div class="text-name">{{ userNickName }}</div>
                <img class="icon-vip" v-if="userRole==='vip'" src="../../../assets/images/User/icon-vip.png" alt="">
            </div>
            <div class="logout my-cursor" @click.stop="submit">
                退出登录
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "UserInfo",
    props: {
        userPicture: {
            type: String,
            default: "",
        },
        userNickName: {
            type: String,
            default: "",
        },
        userRole: {
            type: String,
            default: "normal",
        },
    },
    methods:{
        close: function(){
            this.$emit("closeEvent");
        },
        submit: function(){
            this.$emit("submitEvent");
            this.close();
        },
    },

}
</script>

<style scoped>
div.body-user-info{
    width: 1.5rem;
    background: #FFFFFF;
    box-shadow: 0 0.04rem 0.15rem 0 rgba(0,0,0,0.1);
    border-radius: 0.1rem;
    border: 0.02rem solid #010101;
    margin-top: 0.6rem;
    margin-left: 0.3rem;
    padding-top: 0.12rem;
    box-sizing: border-box;
    overflow: hidden;
}
img.user-picture{
    width: 0.38rem;
    height: 0.38rem;
    display: block;
    border-radius: 0.05rem;
    margin: auto;

}
div.user-nick-name{
    width: 90%;
    height: 0.2rem;
    margin: 0.05rem auto auto;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.05rem;
}
div.text-name{

    height: 100%;
    font-weight: bold;
    font-size: 0.16rem;
    color: #000000;
    line-height: 0.2rem;
    text-align: center;
    font-style: normal;

    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
img.icon-vip{
    width: 0.16rem;
    height: 0.14rem;
}
div.logout{
    width: 100%;
    height: 0.36rem;

    font-weight: bold;
    font-size: 0.15rem;
    color: #FC8470;
    line-height: 0.36rem;
    text-align: center;
    margin-top: 0.65rem;
}
div.logout:hover{
    background: #FFEFB4;
}
</style>